import { Accordion, AccordionTab } from "primereact/accordion";
import React, { useEffect, useState } from "react";
import BottomSheetViewEdit from "../BookNewOrder/BottomSheetViewEdit";
import { useNavigate } from "react-router-dom";
import OrderDeleteModal from "./OrderDeleteModal";

const GarmentInfoCard = ({
  orderItemData,
  storeCustomerId,
  storeId,
  bookingOrderId,
  brandId,
  priceId,
  sendDataToOrderGarmentInfo,
  offerDiscountByStore,
  offerDiscountByRider,
  userRole,
  offerPriceEnabled,
  garmentMaxProcessCount,
  garmentServiceIcons,
  orderEditByStore,
  enableDeleteItem,
  b2BChallanOrder,
  enabledAmountRoundOff
}) => {
  const navigate = useNavigate();

  const [modalVisible, setModalVisible] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalStatusText, setModalStatusText] = useState("");

  const [selectedItem, setSelectedItem] = useState(null);
  const [offerEdit, setOfferEdit] = useState("");
  const [deleteOrderModal, setDeleteOrderModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState("")

  useEffect(() => {
    setSelectedItem(orderItemData ? orderItemData[0]?.id : null);
  }, [orderItemData]);

  const handleItemPress = (item) => {
    setSelectedItem((prevSelectedItem) =>
      prevSelectedItem === item.id ? null : item.id
    );
  };

  const [visible, setVisible] = useState(false);
  const [selectedGarment, setSelectedGarment] = useState({});

  const toggleBottomNavigationView = (item) => {
    setSelectedGarment(item);
    //Toggling the visibility state of the bottom sheet
    setVisible(!visible);
  };

  const toggleBottomNavigationViewClosed = () => {
    setVisible(false);
    setOfferEdit("");
    sendDataToOrderGarmentInfo({
      info: true,
    });
  };

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    IN_PROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "#E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  return (
    <div className="mx-2 my-3">
      <Accordion>
        {orderItemData?.map((item, index) => {
          const orderStatusColor =
            OrderStatusColors[item.status] || OrderStatusColors.DEFAULT;

          const serviceName = item.addOns
            .map((addOnItem) => addOnItem.serviceName)
            .join(", ");
          const offerPrice = item.addOns
            .map((addOnItem) => addOnItem.offerPrice)
            .join(", ");
          const garmentName =
            item.garmentAlias !== "" ? item.garmentAlias : item.garmentName;
          const remarks = item.remarks !== "" ? item.remarks : "";
          const bookingType =
            item.bookingType === "PackageBooking" ? "Package" : "General";

          const removeGarment = orderItemData?.length > 1 ? true : false;

          return (
            <AccordionTab
              key={index}
              style={{
                "--backgroundColor-AccordionTab": orderStatusColor,
              }}
              // header={`${index + 1 || "N/A"} |  ${garmentName.replace(
              //   /_/g,
              //   " "
              // )}`}
              header={
                <div
                  className="flex align-items-center justify-content-between w-full"
                  style={{ width: "100%" }}
                >
                  {/* Left side - title */}
                  <span className="font-semibold">
                    {index + 1 || "N/A"} | {garmentName.replace(/_/g, " ")}
                  </span>

                  {/* Right side - delete icon */}
                  {userRole !== "BY_SUPPORT_ADMIN" && <div>
                    {
                      enableDeleteItem &&
                      removeGarment &&
                      ["BOOKED", "IN_PROCESS"].includes(
                        item.status
                      ) &&
                      bookingType === "General" &&
                      (
                        userRole === "BY_ADMIN" ||
                        (userRole === "BY_STORE" && orderEditByStore)
                      ) && !b2BChallanOrder && (

                        <img
                          src={
                            "images/delete.png"
                          }
                          style={{
                            position: "absolute",
                            right: 60,
                            width: 23,
                            height: 23,
                            top: 10,
                            alignSelf: "center",
                          }}
                          onClick={(e) => {
                            // e.stopPropagation(); // 🔴 prevents accordion toggle
                            setSelectedItemId(item.id);
                            setDeleteOrderModal(true)
                          }}
                        />
                      )}
                  </div>}
                </div>
              }
            >
              <div className="cursor-pointer">
                <div className="flex-row">
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">
                      Service:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {serviceName || "N/A"}
                    </p>
                  </div>
                  <div className="col-6 flex justify-content-between">
                    <div>
                      <p className="text-base font-semiBold capitalize">
                        Total Price:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {item.totalPrice || 0}
                      </p>
                    </div>
                    {userRole !== "BY_SUPPORT_ADMIN" && <div className="flex align-items-center">
                      {
                        userRole !== "BY_SUB_ADMIN_USER" &&
                        userRole !== "BY_FRANCHISE_ADMIN" &&
                        ["BOOKED", "IN_PROCESS"].includes(
                          item.status
                        ) &&
                        item.bookingType === "GeneralBooking" && (
                          <div className="flex align-items-center gap-5">
                            {!b2BChallanOrder && <div
                              onClick={() => {
                                toggleBottomNavigationView(item);
                                setOfferEdit("price");
                              }}
                            >
                              <i
                                className="pi pi-pencil"
                                style={{
                                  fontSize: "20px",
                                  cursor: "pointer",
                                  color: "#2B70D7",
                                }}
                              ></i>
                            </div>}
                            {!b2BChallanOrder && <div
                              className="relative"
                              onClick={() => {

                                offerDiscountByStore &&
                                  toggleBottomNavigationView(item);
                                setOfferEdit("offer");
                              }}
                            >
                              <img
                                src={
                                  "Laundy_App_Icons_Gifs/SettingIcons/gift.png"
                                }
                                style={{
                                  width: 23,
                                  height: 23,
                                  alignSelf: "center",
                                }}
                              />
                              {userRole === "BY_STORE" &&
                                !offerDiscountByStore && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: -5,
                                      top: 8,
                                    }}
                                  >
                                    <img
                                      src={"Icons/lock.png"}
                                      style={{
                                        width: 19,
                                        height: 19,
                                        backgroundColor: "transparent",
                                      }}
                                    />
                                  </div>
                                )}
                            </div>}
                          </div>
                        )}
                    </div>}
                  </div>
                </div>

                <div className="flex-row">
                  <div className="col-6">
                    <div className="flex">
                      <p className="text-base font-semiBold capitalize mr-3">
                        Garment Count:
                      </p>
                      {item.itemGarmentCount > 1 && userRole !== "BY_SUPPORT_ADMIN" && (
                        <div
                          onClick={() =>
                            navigate("/GarmentTags", {
                              state: {
                                storeCustomerId: storeCustomerId,
                                bookingOrderId: bookingOrderId,
                                orderItemId: item.id,
                              },
                            })
                          }
                        >
                          <i
                            className={"pi pi-eye"}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "#2B70D7",
                            }}
                          ></i>
                        </div>
                      )}
                    </div>
                    <p className="text-lg font-bold capitalize">
                      {item.itemGarmentCount || 0}
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">
                      Remark:
                    </p>
                    <p className="text-lg font-bold capitalize">{remarks}</p>
                  </div>
                </div>
                <div className="flex-row">
                  <div className="flex-row">
                    <div className="col-6">
                      <p className="text-base font-semiBold capitalize">
                        Price/ Pc:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {offerPrice}
                      </p>
                    </div>

                    <div className="col-6">
                      <p className="text-base font-semiBold capitalize">
                        Status:
                      </p>
                      <p
                        className="text-lg font-bold capitalize"
                        style={{ color: orderStatusColor }}
                      >
                        {item.status.replace(/_/g, " ")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex-row">
                  <div className="flex-row">
                    <div className="col-6">
                      <p className="text-base font-semiBold capitalize">
                        Pack on:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {item.garmentPack}
                      </p>
                    </div>

                    <div className="col-6">
                      <p className="text-base font-semiBold capitalize">
                        Booking Type:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {bookingType}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionTab>
          );
        })}
      </Accordion>

      <BottomSheetViewEdit
        visible={visible}
        toggleBottomNavigationView={toggleBottomNavigationView}
        toggleBottomNavigationViewClosed={toggleBottomNavigationViewClosed}
        selectedGarment={selectedGarment}
        storeCustomerId={storeCustomerId}
        storeId={storeId}
        bookingOrderId={bookingOrderId}
        brandId={brandId}
        priceId={priceId}
        offerEdit={offerEdit}
        offerPriceEnabled={offerPriceEnabled}
        garmentMaxProcessCount={garmentMaxProcessCount}
        garmentServiceIcons={garmentServiceIcons}
        enabledAmountRoundOff={enabledAmountRoundOff}
      />
      <OrderDeleteModal
        setDeleteOrderModal={setDeleteOrderModal}
        deleteOrderModal={deleteOrderModal}
        sendDataToOrderInfoPage={sendDataToOrderGarmentInfo}
        storeId={storeId}
        storeCustomerId={storeCustomerId}
        bookingOrderId={bookingOrderId}
        itemId={selectedItemId}
      />
    </div>
  );
};

export default GarmentInfoCard;
